import { X_PAGE_ID } from 'reactApp/appHelpers/configHelpers';

let i = 0;

export const uid = () => {
    return `${X_PAGE_ID}-${Date.now().toString(36)}-${i++}`;
};
